module.exports = __webpack_public_path__ + "static/img/baishi.4ce3ad15.png";